var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVr = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 234,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#FFB800",
  strokeWidth: 0.765,
  d: "m15 112-7 7-7-7 7-7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#FFB800",
  strokeWidth: 0.765,
  d: "M12.06 112 8 116.06 3.94 112 8 107.94z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB800",
  strokeOpacity: 0.5,
  d: "M8.5 129v105M8.5 0v94"
})));
export { SvgVr as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjM0IiB2aWV3Qm94PSIwIDAgMTYgMjM0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE1IiB5PSIxMTIiIHdpZHRoPSI5Ljg5OTU0IiBoZWlnaHQ9IjkuODk5NTQiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxNSAxMTIpIiBzdHJva2U9IiNGRkI4MDAiIHN0cm9rZS13aWR0aD0iMC43NjQ2NjkiLz4KPHJlY3Qgb3BhY2l0eT0iMC41IiB4PSIxMi4wNTkzIiB5PSIxMTIiIHdpZHRoPSI1Ljc0MDg4IiBoZWlnaHQ9IjUuNzQwODgiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxMi4wNTkzIDExMikiIHN0cm9rZT0iI0ZGQjgwMCIgc3Ryb2tlLXdpZHRoPSIwLjc2NDY2OSIvPgo8bGluZSB4MT0iOC41IiB5MT0iMTI5IiB4Mj0iOC41IiB5Mj0iMjM0IiBzdHJva2U9IiNGRkI4MDAiIHN0cm9rZS1vcGFjaXR5PSIwLjUiLz4KPGxpbmUgeDE9IjguNSIgeTE9Ii0yLjE4NTU3ZS0wOCIgeDI9IjguNSIgeTI9Ijk0IiBzdHJva2U9IiNGRkI4MDAiIHN0cm9rZS1vcGFjaXR5PSIwLjUiLz4KPC9zdmc+Cg==";